import React, { useState } from 'react';
import { Button, Tooltip, Badge } from 'antd';
import { RobotOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const AIFloatingButton = () => {
  const navigate = useNavigate();
  const [hasNewFeature, setHasNewFeature] = useState(true); // Show badge for new feature

  const handleOpenAI = () => {
    navigate('/ai-agent');
    setHasNewFeature(false); // Remove badge after first interaction
  };

  return (
    <>
      {/* Floating AI Button */}
      <div
        style={{
          position: 'fixed',
          bottom: '24px',
          right: '24px',
          zIndex: 1000,
        }}
      >
        <Tooltip title="🤖 AI Assistant - Ask me to create leads, deals, meetings, tasks & reports!" placement="left">
          <Badge dot={hasNewFeature} color="#52c41a">
            <Button
              type="primary"
              shape="circle"
              size="large"
              icon={<RobotOutlined />}
              onClick={handleOpenAI}
              style={{
                width: '60px',
                height: '60px',
                fontSize: '24px',
                boxShadow: '0 4px 12px rgba(24, 144, 255, 0.4)',
                background: 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)',
                border: 'none',
                animation: hasNewFeature ? 'pulse 2s infinite' : 'none'
              }}
            />
          </Badge>
        </Tooltip>
      </div>

      {/* CSS Animation */}
      <style>{`
        @keyframes pulse {
          0% {
            transform: scale(1);
            box-shadow: 0 4px 12px rgba(24, 144, 255, 0.4);
          }
          50% {
            transform: scale(1.05);
            box-shadow: 0 6px 20px rgba(24, 144, 255, 0.6);
          }
          100% {
            transform: scale(1);
            box-shadow: 0 4px 12px rgba(24, 144, 255, 0.4);
          }
        }
      `}</style>
    </>
  );
};

export default AIFloatingButton;
